// Shared by usePurchaseLinkLocation and usePurchaseLinkPreloadAllLocations —
// both retry a location's accounts/5/subscriptions fetch while this returns
// true, since a brand-new account's baseline "Command Center" subscriptions
// (My Account Basic+, Reporting Center) and that base plan's own bundled
// add-ons (Signatures Usage, Website Builder) can each still be provisioning
// server-side for a moment after account creation — confirmed live: the base
// plan subscription itself can appear with an *empty* `addons` array for one
// fetch cycle before its bundled add-ons attach, so checking only "is there
// an active subscription at all" isn't enough — a $0 baseline plan with no
// addons yet is itself a sign provisioning isn't finished. A genuinely
// addon-less paid plan (nonzero unitAmount) is left alone — only a $0
// subscription with zero addons is treated as still-incomplete.
export function hasNoActiveSubscriptions(recurlyAccountInfo) {
  const subs = [
    ...(recurlyAccountInfo?.parentSubscriptions ?? []),
    ...(recurlyAccountInfo?.childSubscriptions ?? []),
  ]
  const active = subs.filter(sub => sub.state === 'active')
  if (!active.length) return true

  const hasSettledSubscription = active.some(
    sub =>
      Number(sub.unitAmount ?? sub.subtotal ?? 0) > 0 ||
      (sub.addons ?? []).length > 0,
  )
  return !hasSettledSubscription
}
